import React from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'

type Props = {
  className: string
  ratingdata: any
}
const StarRating: React.FC<Props> = ({ className, ratingdata }) => {
  const fiveStarRating =
    ratingdata?.ratingsBreakdown?.five === null ? 0 : ratingdata?.ratingsBreakdown?.five?.toFixed(1)
  const fourStarRating =
    ratingdata?.ratingsBreakdown?.four === null ? 0 : ratingdata?.ratingsBreakdown?.four?.toFixed(1)
  const threeStarRating =
    ratingdata?.ratingsBreakdown?.three === null ? 0 : ratingdata?.ratingsBreakdown?.three?.toFixed(1)
  const twoStarRating =
    ratingdata?.ratingsBreakdown?.two === null ? 0 : ratingdata?.ratingsBreakdown?.two?.toFixed(1)
  const oneStarRating =
    ratingdata?.ratingsBreakdown?.one === null ? 0 : ratingdata?.ratingsBreakdown?.one?.toFixed(1)
  const avgStarRating = ratingdata?.averageRating === null ? 0 : ratingdata?.averageRating
  const totalStarRating =
    ratingdata?.totalRatedChatrooms === null ? 0 : ratingdata?.totalRatedChatrooms

  const starRatingNumber = [1, 2, 3, 4, 5]

  const renderStarIcon = (starRatingValue: any, avgStarRatingValue: any) => {
    if (starRatingValue <= avgStarRatingValue) {
      return <i className='bi bi-star-fill fs-6'></i>
    } else if (
      Math.floor(avgStarRatingValue) &&
      Math.ceil(avgStarRatingValue) === starRatingValue
    ) {
      return <i className='bi bi-star-half fs-6'></i>
    } else {
      return <i className='bi bi-star fs-6'></i>
    }
  }

  return (
    <>
      <div className={`card ${className} p-10`}>
        <div className='card text-center'>
          <div className=' fw-bolder text-dark fs-3 mb-3 text-hover-primary  align-self-center'>
            Bot Feedback Ratings
          </div>
        </div>

        {/* begin::Body */}
        <div className='card-body row '>
          <span></span>
          <div className='col-md-4 text-center bi bi-algin-center  align-self-center'>
            <span className='fw-bold text-primary  display-3'>{avgStarRating}</span>
            <span>&nbsp;&nbsp;</span>
            <br></br>

            <div className='rating ' style={{ position: 'relative', left: '15px' }}>
              {starRatingNumber.map((starRatingValue, index) => (
                <div key={index} className='rating-label me-2 checked'>
                  {renderStarIcon(starRatingValue, avgStarRating)}
                </div>
              ))}
            </div>
            <span className='fw-bold text-muted align-self-center fs-2'>({totalStarRating})</span>
          </div>

          <div className='col-md-8 '>
            <div className='d-flex '>
              <sub className='fs-3'>5 &nbsp;</sub>
              <div className='col'>
                <ProgressBar animated now={fiveStarRating} />
              </div>
              <sub className='fs-4 text-primary'>&nbsp;{fiveStarRating}%</sub>
            </div>
            <br></br>

            <div className='d-flex'>
              <sub className='fs-3 float-start'>4 &nbsp;</sub>
              <div className='col'>
                <ProgressBar animated now={fourStarRating} />
              </div>
              <sub className='fs-4 text-primary float-end'> &nbsp;{fourStarRating}%</sub>
            </div>

            <br></br>

            <div className='d-flex'>
              <sub className='fs-3 float-start'>3 &nbsp;</sub>
              <div className='col'>
                <ProgressBar animated now={threeStarRating} />
              </div>
              <sub className='fs-4 text-primary float-end'>&nbsp;{threeStarRating}%</sub>
            </div>
            <br></br>
            <div className='d-flex'>
              <sub className='fs-3 float-start'>2 &nbsp;</sub>
              <div className='col'>
                <ProgressBar animated now={twoStarRating} />
              </div>
              <sub className='fs-4 text-primary float-end'>{twoStarRating}%</sub>
            </div>
            <br></br>
            <div className='d-flex'>
              <sub className='fs-3 float-start'>1 &nbsp;</sub>
              <div className='col'>
                <ProgressBar animated now={oneStarRating} />
              </div>
              <sub className='fs-4 text-primary float-end'>{oneStarRating}%</sub>
            </div>
          </div>
        </div>

        {/* end:Body */}
      </div>
    </>
  )
}

export default StarRating
